import { render, staticRenderFns } from "./SeriesCard.vue?vue&type=template&id=479b3535&scoped=true&"
import script from "./SeriesCard.vue?vue&type=script&lang=js&"
export * from "./SeriesCard.vue?vue&type=script&lang=js&"
import style0 from "./SeriesCard.vue?vue&type=style&index=0&id=479b3535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b3535",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479b3535')) {
      api.createRecord('479b3535', component.options)
    } else {
      api.reload('479b3535', component.options)
    }
    module.hot.accept("./SeriesCard.vue?vue&type=template&id=479b3535&scoped=true&", function () {
      api.rerender('479b3535', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Series/Includes/SeriesCard.vue"
export default component.exports